import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import { Button } from './ui/button';

export const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="bg-white border-b border-gray-100">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img src="/assets/cl-heart.png" alt="Connect Legacy" className="h-14 w-14 object-contain" />
            <span className="text-xl font-bold text-gray-900">Connect Legacy</span>
          </Link>
          <Link to="/">
            <Button variant="ghost" className="text-gray-600 hover:text-[#7E33E0]">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Home
            </Button>
          </Link>
        </div>
      </header>

      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 max-w-3xl">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 bg-[#7E33E0]/10 rounded-xl flex items-center justify-center">
            <FileText className="h-6 w-6 text-[#7E33E0]" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900">Terms of Use</h1>
        </div>

        <p className="text-sm text-gray-500 mb-10">Last updated: June 2026</p>

        <div className="space-y-10 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">1. About Connect Legacy</h2>
            <p>Connect Legacy is a digital legacy planning platform currently in development. The website and related services are provided for informational purposes and to allow users to join our waitlist and receive updates.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">2. Demo Status</h2>
            <p>Connect Legacy is currently in a pre-launch phase. Features, functionality, pricing, and availability may change without notice.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">3. Waitlist Registration</h2>
            <p>Joining the waitlist does not guarantee access to the platform, specific features, or launch dates. Users may receive updates regarding product development and future availability.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">4. User Responsibilities</h2>
            <p>Users agree to provide accurate information when submitting forms through the website and not to use the website for unlawful or harmful purposes.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">5. Intellectual Property</h2>
            <p>All content, branding, logos, graphics, text, and materials on this website are the property of Connect Legacy unless otherwise stated and may not be copied, reproduced, or distributed without permission.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">6. No Professional Advice</h2>
            <p>Information provided on this website is for general informational purposes only and should not be considered legal, financial, estate planning, or professional advice.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">7. Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, Connect Legacy shall not be liable for any direct, indirect, incidental, or consequential losses arising from the use of this website.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">8. Changes</h2>
            <p>We may update these Terms of Use at any time. Continued use of the website constitutes acceptance of any updated terms.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">9. Contact</h2>
            <p>
              For questions regarding these Terms of Use, please contact us at:{' '}
              <a href="mailto:support@connect-legacy.com" className="text-[#7E33E0] hover:underline font-medium">
                support@connect-legacy.com
              </a>
            </p>
          </section>
        </div>
      </main>

      <footer className="bg-gray-950 text-gray-400 py-8 px-4 mt-16">
        <div className="container mx-auto max-w-6xl text-center text-xs">
          © 2026 Connect Legacy. All rights reserved.
        </div>
      </footer>
    </div>
  );
};
